import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms">
      {/* Hero */}
      <section className="terms-hero">
        <div className="container">
          <motion.div
            className="terms-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/" className="back-link">
              <FaArrowLeft />
              Volver al inicio
            </Link>
            <h1>Términos y Condiciones</h1>
            <p className="subtitle">
              Condiciones que regulan el uso de esta web y la contratación de nuestros servicios.
            </p>
            <div className="last-updated">
              <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES')}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contenido */}
      <section className="terms-content section">
        <div className="container">
          <div className="terms-sections">
            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h2>1. Identificación</h2>
              <p>
                Esta web es titularidad de Javier Muñoz Velasco con Número de Colegiado: 017693
              </p>
            </motion.div>

            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <h2>2. Objeto y Aceptación</h2>
              <p>
                El acceso y uso de esta web implica la aceptación de estos Términos y Condiciones. Si no estás de acuerdo, por favor, no utilices el sitio.
              </p>
            </motion.div>

            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h2>3. Uso del Sitio</h2>
              <ul>
                <li>Te comprometes a hacer un uso lícito y responsable.</li>
                <li>No realizarás acciones que puedan dañar, inutilizar o sobrecargar la web.</li>
                <li>La información ofrecida es de carácter general y no sustituye la evaluación clínica individual.</li>
              </ul>
            </motion.div>

            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <h2>4. Citas, Cancelaciones y Pagos</h2>
              <ul>
                <li>Las citas pueden solicitarse vía web, teléfono o WhatsApp.</li>
                <li>Cancelaciones: avisa con al menos 24h. Las cancelaciones fuera de plazo podrán conllevar cargo.</li>
                <li>Precios: los publicados pueden variar; se confirmarán al reservar.</li>
                <li>Los pagos se realizan en la clínica por los medios disponibles.</li>
              </ul>
            </motion.div>

            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h2>5. Propiedad Intelectual</h2>
              <p>
                Los contenidos, diseño e imágenes de esta web están protegidos por derechos de propiedad intelectual. No se permite su reproducción sin autorización.
              </p>
            </motion.div>

            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <h2>6. Responsabilidad</h2>
              <p>
                No soy responsable de daños derivados del uso de la web ni de los enlaces a sitios de terceros. La atención clínica siempre se realiza por profesionales colegiados.
              </p>
            </motion.div>

            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <h2>7. Protección de Datos y Cookies</h2>
              <p>
                El tratamiento de datos personales se regula en la <Link to="/privacidad">Política de Privacidad</Link>. 
                Puedes gestionar tus preferencias de cookies desde el enlace “Preferencias de Cookies” del pie de página.
              </p>
            </motion.div>

            <motion.div
              className="terms-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              viewport={{ once: true }}
            >
              <h2>8. Modificaciones y Ley Aplicable</h2>
              <p>
                Podré modificar estos Términos cuando sea necesario. La ley aplicable será la española y los tribunales de [localidad] serán competentes salvo normativa imperativa.
              </p>
            </motion.div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms; 